module.exports = __webpack_public_path__ + "img/JDB.d864aef8.webp";